module.exports = "https://static.futunn.com/components/common-redpacket-prize-list/images/pc-bg.f83543e268.png";